// extracted by mini-css-extract-plugin
export default {"root":"arn5L"};